export { default as default, StoreGetter, StoreAction } from './store-module-service.ts';
